import React from 'react';
import { CheckIcon } from 'lucide-react';
export const ProductShowcase = () => {
  return <section id="features" className="w-full py-16 md:py-24 px-6 md:px-12 bg-white dark:bg-gray-900" data-id="element-166">
      <div className="max-w-6xl mx-auto" data-id="element-167">
        <div className="flex flex-col md:flex-row items-center" data-id="element-168">
          <div className="md:w-1/2 mb-10 md:mb-0 md:pr-12" data-id="element-169">
            <h2 className="text-2xl md:text-3xl font-bold mb-6" data-id="element-170">
              Powerful compliance automation—less work, fewer errors.
            </h2>
            <ul className="space-y-4" data-id="element-171">
              <li className="flex items-start" data-id="element-172">
                <CheckIcon size={20} className="text-green-500 mt-1 mr-3 flex-shrink-0" data-id="element-173" />
                <span className="text-gray-700 dark:text-gray-300" data-id="element-174">
                  Normalize automatically to CMS schema from any source.
                </span>
              </li>
              <li className="flex items-start" data-id="element-175">
                <CheckIcon size={20} className="text-green-500 mt-1 mr-3 flex-shrink-0" data-id="element-176" />
                <span className="text-gray-700 dark:text-gray-300" data-id="element-177">
                  Flag and fix gaps before publishing.
                </span>
              </li>
              <li className="flex items-start" data-id="element-178">
                <CheckIcon size={20} className="text-green-500 mt-1 mr-3 flex-shrink-0" data-id="element-179" />
                <span className="text-gray-700 dark:text-gray-300" data-id="element-180">
                  Publish with confidence via a hosted 'Compliant' page +
                  downloadable file.
                </span>
              </li>
              <li className="flex items-start" data-id="element-181">
                <CheckIcon size={20} className="text-green-500 mt-1 mr-3 flex-shrink-0" data-id="element-182" />
                <span className="text-gray-700 dark:text-gray-300" data-id="element-183">
                  Stay current as CMS requirements change.
                </span>
              </li>
            </ul>
            <button className="mt-8 px-6 py-3 bg-green-600 hover:bg-green-700 text-white rounded-md text-base font-medium transition-colors" data-id="element-184">
              See RootHealth in Action
            </button>
          </div>
          <div className="md:w-1/2" data-id="element-185">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/4AoppbnyesUvrDxy46jC2G/unnamed_%281%29.png" alt="RootHealth COMPLIANT shield logo with heart symbol" className="w-[45%] h-auto mx-auto" data-id="element-186" />
          </div>
        </div>
      </div>
    </section>;
};